import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_services-details.scss';
import '../../sass/_home.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Header from '../../components/header';

export default class index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Header name="services" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>

                    <div>
                        <section className="animejs-code">
                            <Container>
                                <div className="mt-sm-3 pt-sm-5">
                                    <Row>
                                        <Col className="pr-sm-0" md={7}>
                                            <div className="pl-sm-3 pt-5">
                                                <div className="">
                                                    <div className="count">04</div>
                                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                                </div>
                                                <div className="big-heading pt-sm-2 get-0909">Branding and Digital Marketing</div>
                                                <div className="main-content pt-sm-5">Marketing is not about making a sale. It is about narrating your story, making relationships and building trust.</div>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <video className="width-vedio" autoPlay loop playsInline muted>
                                            <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio.mp4`} type="video/mp4" />
                                            </video>
                                        </Col>
                                    </Row>
                                </div>
                                <br />
                                <br />
                            </Container>
                        </section>

                        <section className="" id="Brand-Identity">
                            <Container className="pt-sm-5">
                                <Row>
                                <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Branding-s.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Brand Identity</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-7" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            A brand’s identity lies in its visible elements, such as color, design, and logo that 
                                            help it stand out in consumers' minds. What we at AxlrData do is build a positive brand 
                                            image that brings in consistent sales and make the product roll-outs far more successful. 
                                            <span class="read-more-target">We build a cohesive brand image by understanding businesses and their market, 
                                            determining the company's goals, customers, and message. We help in establishing 
                                            the brand elements, set the benchmark and tell a compelling visual story through our 
                                            work which is in alignment with the brand’s tone.</span>
                                                </div>
                                        <label for="post-7" class="read-more-trigger"></label>     
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Logo Design</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Letterheads</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Brand Guidelines</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Brochures</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Illustrations</div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Campaign-and-Content-Strategy">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Content_Strategy.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Campaign and Content Strategy</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-8" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            We understand the difference between content strategy and curated campaigns. 
                                            While campaigns yield faster results, content strategy helps set the brand tone 
                                            in terms of its communication. When handling businesses, we ideate on the ways 
                                            <span class="read-more-target">in which a brand’s message can be communicated to its' target audience. We come up 
                                            with ideas via campaigns and optimize strategies that eventually help brands penetrate 
                                            the market and attain a certain brand value.</span>
                                                </div>
                                        <label for="post-8" class="read-more-trigger"></label>     
                                        </div>
                                       
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Campaign Strategy</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Market Research</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Content Strategy</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Content Calendar</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Content_Strategy.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Campaign-Management">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/campaign_strategy.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Campaign Management</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-9" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            Campaign management requires diligent planning, timely execution, and a lot 
                                            of knowledge and insight into the audience you’re reaching out to. While developing 
                                            and planning campaigns, we take a lot of factors into consideration - target geographies, 
                                            demographics, age group,<span class="read-more-target"> among many others. What starts with research and ideation leads to 
                                            execution and analysis with campaign management being centered around a launch, a particular 
                                            event or an activity. The campaigns we curate normally involve multiple pushes to potential buyers 
                                            through email, social media, surveys, print materials, giveaways, etc. all focusing on a similar topic 
                                            or idea: appropriately positioning/introducing the brand by accessing various touchpoints.</span>
                                                </div>
                                        <label for="post-9" class="read-more-trigger"></label>     
                                        </div>
                                       
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Campaign Ideation</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Target Group Segmentation</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Campaign Strategy</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Campaign Planning and Scheduling</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Campaign Optimization</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="SEO">
                            <Container className="mt-5 pt-5">
                                <Row>
                                <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/SEO.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">SEO</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-10" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            It is imperative for us that when we position a business, we ensure that it’s 
                                            visibility as at its prime. Increasing the quality and quantity of website 
                                            traffic for us is as important as the brand’s identity. Our team researches the keywords 
                                            that act as <span class="read-more-target">traffic-magnets, and attract the right target audience for your business. 
                                            We first understand the target audience and segregate keywords based on various demographics 
                                            such as age, interests, and location. By optimizing this aspect, we ensure that the traffic 
                                            we generate for our partners remains organic, authentic and result-driven.</span>
                                                </div>
                                        <label for="post-10" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Keyword Identification</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">On-page SEO</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Technical SEO</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Content Development</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Target Audience Segregation</div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/SEO.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Print-Digital-Media">
                            <Container className="mt-sm-5 pt-sm-5">
                                <Row>
                                <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Media.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Print & Digital Media</div>
                                        <div>
                                        <input type="checkbox" class="read-more-state" id="post-11" />
                                        <div className="spectial-content pt-4 read-more-wrap">
                                            Owing to the digital revolution, it has become essential for any business to 
                                            have a strong presence in all possible mediums. We enable our partner’s growth 
                                            in all viable spheres. <span class="read-more-target">We ideate on creating various visuals that on executing, 
                                            run for both print and social media campaigns, depending on the requirement. 
                                            Each ad we create adds value to the business, thereby, creating strong brand recall 
                                            and customer retention.</span>
                                                </div>
                                        <label for="post-11" class="read-more-trigger"></label>     
                                        </div>
                                        
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Hoardings</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Social Media Ads</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Flyers</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Brochures</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <TalkData title={<span> Let 's take your brand <br />to the people!</span>} subtitle="We’d love to talk about what matters to you." />
                    </div>

                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .ta9990pj{
                        font-size: 30px !important;
                        font-weight: 900;
                    }
                    @media only screen and (max-width: 768px){
                        .big-heading {
                            font-size: 45px !important;
                            line-height: 55px !important;
                            padding-bottom: 25px;
                            padding-top: 35px !important;
                        }
                    }
                    `}
                </style>
            </div>
        )
    }
}
